import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import BoxWrapper from 'components/atoms/BoxWrapper';
import { fonts } from 'theme/Variables';
import Button from 'components/atoms/Button/Button';
import CustomTypography from 'components/atoms/CustomTypography';
import styled from 'styled-components';
import { Redirect } from 'react-router';
import { routes } from 'routes/Routes';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';
import { types } from 'actions/authentication/types';
import thankYouImg from '../../assets/img/thankyou.svg';

const StyledLink = styled.a`
    text-decoration: none;
`;

const Image = styled.img`
    width: 75%;
`;

class ThankYouPage extends Component {
    constructor(props) {
        super(props);

        this.dispatch = props.dispatch;
        this.isRegisterSuccess = props.authentication.isRegisterSuccess;
    }

    componentWillUnmount() {
        this.dispatch({ type: types.REGISTRATION_SUCCESS, payload: false });
    }

    render() {
        return (
            <>
                <HeaderTemplate title="Thank You" />
                <Container>
                    <BoxWrapper mt="50">
                        <Grid container justify="center">
                            <Grid item xs={12} md={4}>
                                <BoxWrapper mb="25" justifyContent="flex-start">
                                    <CustomTypography
                                        variant="h3"
                                        fontSize="2.6"
                                        customfont={fonts.secondary}
                                    >
                                        Welcome to Mobilise Moments - we’re pleased to have you with
                                        us
                                    </CustomTypography>
                                </BoxWrapper>
                                <BoxWrapper>
                                    <Image src={thankYouImg} alt="thank you image" />
                                </BoxWrapper>
                                <BoxWrapper mb="20" mt="20" decorLeft justifyContent="flex-start">
                                    <CustomTypography>
                                        You will receive your first Mobilise Moment at the time you selected.
                                    </CustomTypography>
                                </BoxWrapper>
                                <BoxWrapper mb="45" decorLeft justifyContent="flex-start">
                                    <CustomTypography>
                                        If that time has passed for today, you will receive your first Mobilise Moment tomorrow.
                                    </CustomTypography>
                                </BoxWrapper>
                            </Grid>

                            <Grid item xs={12}>
                                <BoxWrapper>
                                    <StyledLink
                                        href="https://www.facebook.com/groups/Mobilisecommunity/"
                                        target="_blank"
                                    >
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                        >
                                            Join our Facebook group
                                        </Button>
                                    </StyledLink>
                                </BoxWrapper>
                            </Grid>
                        </Grid>
                    </BoxWrapper>
                    {!this.isRegisterSuccess && <Redirect to={routes.homeRoute} />}
                </Container>
            </>
        );
    }
}

const mapStateToProps = ({ authentication }) => {
    return { authentication };
};

export default connect(mapStateToProps, null)(ThankYouPage);
